// extracted by mini-css-extract-plugin
export var sectionTitle = "bs-description-section-module--section-title--zX6HW";
export var sectionParagraph = "bs-description-section-module--section-paragraph--5nN1v";